export default __webpack_public_path__ + "media/vendor/paper-dashboard-2-pro-html-v2.0.1/assets/img/flags/EE-0c05810172ea269eeb6d468f3eb366cb.png";